const sklRouteBaseName = "skl";

export const sklRoutesNames = {
  root: "skl",
  details: () => `${sklRoutesNames.root}.details`,
};

export const sklRoutes = (basePath: string): any => {
  const path = `${basePath}/${sklRouteBaseName}`;
  return {
    path,
    component: () => import("@/modules/skl/views/layouts/Default.vue"),
    meta: {
      auth: true,
      scope: "contents:skl:read",
      breadcrumb: "SKL",
      scrollTop: true,
    },
    children: [
      {
        path: "",
        name: sklRoutesNames.root,
        component: () => import("@/modules/skl/views/SklListTab.vue"),
        meta: {
          breadcrumb: "SKL list",
        },
      },
      {
        //TODO: change id to sklId
        path: ":id",
        name: sklRoutesNames.details(),
        component: () => import("@/modules/skl/views/SklDetails.vue"),
        meta: {
          breadcrumb: "SKL details",
        },
      },
    ],
  };
};
